import { Outlet } from "react-router";
import { SidebarInset, SidebarProvider, readSidebarOpen } from "@/components/ui/sidebar";
import { ConsentDialog } from "./consent-dialog";
import { AdminSidebar, AppSidebar } from "./sidebar/app-sidebar";

/** 应用壳：sidebar-07（inset）+ 右侧内容。 */
export function AppShell() {
  return (
    <SidebarProvider defaultOpen={readSidebarOpen()}>
      <AppSidebar />
      <SidebarInset className="min-w-0">
        <Outlet />
      </SidebarInset>
      <ConsentDialog />
    </SidebarProvider>
  );
}

export function AdminShell() {
  return (
    <SidebarProvider defaultOpen={readSidebarOpen()}>
      <AdminSidebar />
      <SidebarInset className="min-w-0">
        <Outlet />
      </SidebarInset>
      <ConsentDialog />
    </SidebarProvider>
  );
}
